module.exports = __webpack_public_path__ + "static/media/rnaapp_100.5167c2fa.ico";